export default __webpack_public_path__ + "static/BrownEntrataTT-Bold-600f9298b5d0bcb8f333fabd20502e53.ttf";